module.exports = __webpack_public_path__ + "src/asset/svg/bookmark/v/contact.svg?08b92c4f1edbedb29f69addda9cc0baa";


//////////////////
// WEBPACK FOOTER
// ./src/asset/svg/bookmark/v/contact.svg
// module id = 86
// module chunks = 0